import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";
import { standardReducer } from "@/store/utils.js";

const contentTemplatesReducer = createAsyncReducer({
  name: 'contentTemplates',
  initialState: {
    records: {},
    loading: false,
    errorMessage: ''
  },
  reducers: (create) => ({
    loadOne: create.asyncThunk(
      async ({ name }) => {
        return Fetch.get(Routes.ajax_content_template_path(name));
      },
      standardReducer
    )
  })
});

export default contentTemplatesReducer;